import React, { useState, useEffect } from 'react';
import ItemApi from '../api/ItemApi';
import CategoryApi from '../api/CategoryApi';
import ContactDropdown from '../component/dropdown/ContactDropdown';

const ItemForm = ({type=null, itemId = null, onSubmits, toggle }) => {
    const nonce = devsAccountingApi.nonce;
    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchingItem, setFetchingItem] = useState(false);
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [state, setState] = useState({
        name: "",
        description: "",
        sku: "",
        sale_price: "",
        purchase_price: "",
        category_id: "",
        stock_limit: 0,
        enabled: "",
        exp_date: "",
        image: "",
        previewImage: null, 
        meta: [],
        nonce: nonce,
       
    });

    useEffect(() => {
        getCategory();
        generateSku();
    }, []);

    useEffect(() => {
        if (itemId) {
            getItem(itemId, type);
        }
    }, [itemId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "image") {
            const file = e.target.files[0];
            setState({
                ...state,
                image: file,
                previewImage: URL.createObjectURL(file) // create preview URL
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const generateSku = () => {
        const randomSku = Math.random().toString(36).substring(2, 14).toUpperCase();
        setState({
            ...state,
            sku: randomSku,
        });
    };

    const getItem = async (itemId, type) => {
        setFetchingItem(true);
        const res = await ItemApi.show(itemId, {type});
        if (res) {
            setState(res);
            setFetchingItem(false);
        }
    };

    const categoryOptions = category.map(cat => ({
        value: cat.id,
        label: cat.name,
    }));

    const getCategory = async () => {
        try {
            const res = await CategoryApi.index({type:type}); 
            const filteredCategories = res.filter(cat => cat.type === 'item');
            setCategory(filteredCategories);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (itemId) {
            state.id = itemId;
        }
        if (type) {
            state.type = type;
        }

        let formdata = new FormData();
        Object.keys(state).forEach((key) => {
          
            if (key === 'meta') {
                formdata.append(key, JSON.stringify(state[key]));
            } else {
                formdata.append(key, state[key]);
            }
        });
        const res = await ItemApi.save(formdata);
        if (res.errors) {
            setErrors(res.errors);
            setLoading(false);
        } else {
            setMessage(res.message);
            setLoading(false);
            onSubmits();
            toggle();
        }
    };


// Function to add a new empty meta row
const addMetaRow = () => {
    setState(prevState => ({
        ...prevState,
        meta: [...prevState.meta, { meta_name: '', meta_value: '' }]
    }));
};

// Function to remove a meta row by index
const removeMetaRow = (index) => {
    setState(prevState => {
        const newMeta = [...prevState.meta];
        newMeta.splice(index, 1);
        return {
            ...prevState,
            meta: newMeta,
        };
    });
};

// Function to handle changes in meta fields
const handleMetaChange = (index, field, value) => {
    setState(prevState => {
        const newMeta = [...prevState.meta];
        newMeta[index] = { ...newMeta[index], [field]: value };
        return {
            ...prevState,
            meta: newMeta,
        };
    });
};
    return (
        <div>
            {message &&
                <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                    <p className="font-bold">{message}</p>
                </div>
            }
            {!fetchingItem ?
                <section className="p-6 mx-auto rounded-md">
                    <form onSubmit={handleSubmit}>
                        <div className='grid grid-cols-2'>
                            <div>
                                <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">{itemId ? 'Edit' : 'Add'} Item</h2>
                            </div>
                            <div className="flex justify-end">
                                <button type='submit' className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                                    {loading ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </div>
                        <div className="mt-4 flex gap-6">
                            <div className="w-7/12 gap-4">
                                <div>
                                    <label className="text-gray-700 dark:text-gray-200" htmlFor="name">Name</label>
                                    <input id="name"required type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="name"
                                        value={state.name} onChange={handleChange} />
                                    {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                                </div>

                                <div className="mt-2">
                                    <label className="text-gray-700 dark:text-gray-200" htmlFor="description">Description</label>
                                    <textarea id="description" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="description"
                                        value={state.description} onChange={handleChange} />
                                    {errors.description && <p className="text-red-500 text-xs mt-1">{errors.description}</p>}
                                </div>

                                <div className="mt-2">
                                    <label className="text-gray-700 dark:text-gray-200" htmlFor="sku">UPC/SKU</label>
                                    <div className="flex">
                                        <input onClick={generateSku} id="sku" type="text" required className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="sku"
                                            value={state.sku} onChange={handleChange} />
                                        <button type="button" className="ml-2 px-4 py-2 mt-2 text-white bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600" onClick={generateSku}>
                                            Generate
                                        </button>
                                    </div>
                                    {errors.sku && <p className="text-red-500 text-xs mt-1">{errors.sku}</p>}
                                </div>

                                <div className="mt-2">
                                   
                                   {
                                    type !== 'product' ? (
                                       <> <label className="text-gray-700 dark:text-gray-200">Image</label>
                                       <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                       <div className="space-y-1 text-center">
                                           <svg className="mx-auto h-12 w-12 text-gray-700 dark:text-gray-200" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                               <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                           </svg>
                                           <div className="flex text-sm text-gray-600">
                                               <label htmlFor="file-upload" className="relative cursor-pointer rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                   <span>Upload a file</span>
                                                   <input id="file-upload" name="image" accept='image/*' type="file" className="sr-only" onChange={handleChange} />
                                               </label>
                                               <p className="pl-1 text-gray-700 dark:text-gray-200">or drag and drop</p>
                                           </div>
                                           <p className="text-xs text-gray-700 dark:text-gray-200">
                                               PNG, JPG, GIF up to 10MB
                                           </p>
                                       </div>
                                       </div></>
                                    ) : <p className='text-red-500 text-xs mt-1'>You can't update woocommerce product image</p>
                                   }
                                    {errors.image && <p className="text-red-500 text-xs mt-1">{errors.image}</p>}
                                    {state.previewImage && <img src={state.previewImage} alt="Preview" className="h-32 mt-2 w-auto " />}
                                    {state.image && !state.previewImage && <img src={state.image} alt="Preview" className="h-32 mt-2 w-auto" />}
                                </div>

                                <div className="mt-2">
                                    <label className="text-gray-700 dark:text-gray-200">Meta Information</label>
                                    {state?.meta.map((metaItem, index) => (
                                        <div key={index} className="flex items-center gap-2 mt-2">
                                            <input
                                                type="text"
                                                placeholder="Meta Name"
                                                value={metaItem.meta_name}
                                                onChange={(e) => handleMetaChange(index, 'meta_name', e.target.value)}
                                                className="block w-full px-4 py-2 border border-gray-300 rounded-md"
                                            />
                                            <input
                                                type="text"
                                                placeholder="Meta Value"
                                                value={metaItem.meta_value}
                                                onChange={(e) => handleMetaChange(index, 'meta_value', e.target.value)}
                                                className="block w-full px-4 py-2 border border-gray-300 rounded-md"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeMetaRow(index)}
                                                className="px-2 py-1 bg-red-500 text-white rounded"
                                            >
                                                –
                                            </button>
                                            {index === state.meta.length - 1 && (
                                                <button
                                                    type="button"
                                                    onClick={addMetaRow}
                                                    className="px-2 py-1 bg-green-500 text-white rounded"
                                                >
                                                    +
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                    {state.meta.length === 0 && (
                                        <div className="mt-2">
                                            <button
                                                type="button"
                                                onClick={addMetaRow}
                                                className="px-4 py-2 bg-black text-white rounded"
                                            >
                                                Add Meta
                                            </button>
                                        </div>
                                    )}
                                </div>
                      
                            </div>
                            <div className="w-5/12 gap-4">
                                <div>
                                    <label className="text-gray-700 dark:text-gray-200" htmlFor="sku">Category</label>
                                    <ContactDropdown options={categoryOptions} onSelectChange={handleChange} name="category_id" selectedValue={state.category_id} />
                                    {errors.category_id && <p className="text-red-500 text-xs mt-1">{errors.category_id}</p>}
                                </div>
                                <div className='flex gap-2 mt-2'>
                                    <div className='w-1/2'>
                                        <label className="text-gray-700 dark:text-gray-200" htmlFor="saleprice">Sale Price</label>
                                        <input id="saleprice" required type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="sale_price"
                                            value={state.sale_price} onChange={handleChange} />
                                        {errors.sale_price && <p className="text-red-500 text-xs mt-1">{errors.sale_price}</p>}
                                    </div>
                                    <div className='w-1/2'>
                                        <label className="text-gray-700 dark:text-gray-200" htmlFor="purchaseprice">Buy Price</label>
                                        <input id="purchaseprice" type="number" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="purchase_price"
                                            value={state.purchase_price} onChange={handleChange} />
                                        {errors.purchase_price && <p className="text-red-500 text-xs mt-1">{errors.purchase_price}</p>}
                                    </div>
                                </div>
                                {type === 'product'? (<div>

                                </div>):(
                                    <div className='flex gap-2 mt-2'>
                                    <div className='w-1/2'>
                                        <label className="text-gray-700 dark:text-gray-200" htmlFor="stocklimit">Stock limit</label>
                                        <input id="stocklimit" required type="number" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="stock_limit"
                                            value={state.stock_limit} onChange={handleChange} />
                                        {errors.stock_limit && <p className="text-red-500 text-xs mt-1">{errors.stock_limit}</p>}
                                    </div>
                                    <div className='w-1/2'>
                                        <label className="text-gray-700 dark:text-gray-200" htmlFor="exp_date">Exp date</label>
                                        <input type="date" id="exp_date" className="block w-full px-4 py-1 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="exp_date"
                                            value={state.exp_date} onChange={handleChange} />
                                        {errors.exp_date && <p className="text-red-500 text-xs mt-1">{errors.exp_date}</p>}
                                    </div>
                                </div>

                                )}
                                
                            </div>
                        </div>
                    </form>
                </section>
                : <div className='m-auto'><p className='text-2xl text-bold text-center'>Loading...</p></div>}
        </div>
    )
}

export default ItemForm;
